import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "sidebar no-printable" }
const _hoisted_2 = { class: "sidebar-header mt-3" }
const _hoisted_3 = { class: "sidebar-header__info-user" }
const _hoisted_4 = { class: "sidebar-header__info-user__image tw-flex tw-justify-center mb-3 items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "sidebar-header__info-user__name" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "tw-text-white tw-text-[16px]"
}
const _hoisted_12 = {
  key: 1,
  class: "tw-text-white tw-text-[16px]"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "sidebar-header__info-user__cellphone" }
const _hoisted_15 = { class: "sidebar-header__info-user__email tw-leading-6" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = { class: "menu mt-3" }
const _hoisted_18 = { class: "menu-item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-table" })
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-bar" })
], -1)
const _hoisted_22 = { class: "menu-item" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" })
], -1)
const _hoisted_24 = { class: "menu show" }
const _hoisted_25 = { class: "menu-subitem" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-bar" })
], -1)
const _hoisted_27 = { class: "menu" }
const _hoisted_28 = { class: "menu-subitem" }
const _hoisted_29 = { class: "menu-item" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" })
], -1)
const _hoisted_31 = { class: "menu show" }
const _hoisted_32 = { class: "menu-subitem" }
const _hoisted_33 = { class: "menu-item" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-bar" })
], -1)
const _hoisted_35 = { class: "menu show" }
const _hoisted_36 = { class: "menu-subitem" }
const _hoisted_37 = { class: "menu-item" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" })
], -1)
const _hoisted_39 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  id: "openNoteModalTc",
  class: "btn btn-sm tw-bg-[#FF0000] tw-text-[#FFFFFF] tw-rounded-lg fw-bold ms-auto mb-1",
  style: {"border":"none"},
  "data-bs-toggle": "modal",
  "data-bs-target": "#note-Modal-Message"
}, "SEE NOTE", -1)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { class: "menu-item" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" })
], -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" })
], -1)
const _hoisted_45 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope" })
], -1)
const _hoisted_47 = { class: "menu-item" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog pr-3" }, null, -1)
const _hoisted_49 = { class: "menu-item" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-power-off pr-3" }, null, -1)
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"modal\" id=\"note-Modal-Message\" tabindex=\"-1\" aria-hidden=\"true\" aria-labelledby=\"label-modal-1\"><div class=\"modal-dialog modal-dialog-centered\"><div class=\"modal-content\"><div class=\"modal-body\"><h3 class=\"text-center\"><b>Note:</b></h3><br><p class=\"text-center\"> Use this option to send client information to an MLO, Title Company, or Home Inspector </p><br><div class=\"d-flex justify-content-end\"><button id=\"closeNoteModal\" type=\"button\" class=\"btn tw-bg-[#00a0da] tw-text-[#FFFFFF] tw-rounded-full tw-w-[150px]\" data-bs-dismiss=\"modal\" aria-label=\"Close\"> CLose </button></div></div></div></div></div>", 1)

import UserService from "@/shared/services/user.service";
import { ref, toRefs } from "vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
    usersession: Object,
    userRole: String,
},
  setup(__props) {

const props = __props;

const route = useRoute();
const currentRoute = ref(
    route.path.substring(route.path.lastIndexOf("/") + 1, route.path.length)
);

console.log("Rooute: ", route);



const { usersession, userRole } = toRefs(props);

const cerrarSesion = () => {
    UserService.logout();
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_unref(usersession)?.picture && _unref(userRole) === 'Realtor')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/Images/profile3.png'),
                  alt: ""
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_unref(usersession)?.picture && _unref(userRole) == 'Realtor')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: 'http://api.realtortools.org/uploads/' +
                        _unref(usersession)?.picture
                        ,
                  alt: ""
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_unref(userRole) !== 'Realtor')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  class: "tw-rounded-none tw-w-[70px] tw-h-[80px]",
                  src: require('@/assets/Images/logo-login.png'),
                  alt: ""
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_unref(userRole) != 'Title Company')
              ? (_openBlock(), _createElementBlock("h4", _hoisted_9, [
                  _createTextVNode(_toDisplayString(_unref(usersession).username + " " + _unref(usersession).lastname) + " ", 1),
                  _hoisted_10,
                  (_unref(usersession).role == 'Realtor')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "SL-" + _toDisplayString(_unref(usersession).licensenumber), 1))
                    : _createCommentVNode("", true),
                  (_unref(usersession).role == 'MLO')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "NMLS-" + _toDisplayString(_unref(usersession).licensenumber), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_unref(userRole) == 'Title Company')
              ? (_openBlock(), _createElementBlock("h4", _hoisted_13, _toDisplayString(_unref(usersession).companyname), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", null, _toDisplayString(_unref(usersession).phonenumber
                            ? _unref(usersession).phonenumber
                            : _unref(usersession).phone_Number), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_unref(usersession).email), 1),
            _hoisted_16
          ])
        ])
      ]),
      _createElementVNode("ul", _hoisted_17, [
        _createElementVNode("li", _hoisted_18, [
          (_unref(userRole) != 'MLO' && _unref(userRole) != 'Admin')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "/admin/panel",
                class: _normalizeClass({
                    active:
                        currentRoute.value == 'panel' &&
                        _unref(userRole) != 'MLO' &&
                        _unref(userRole) != 'Admin',
                })
              }, [
                _hoisted_19,
                _createTextVNode("Dashboard")
              ], 2))
            : _createCommentVNode("", true),
          (_unref(userRole) == 'MLO')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                role: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#tablelist",
                class: _normalizeClass({
                    active: _unref(route).path.includes('tables'),
                })
              }, [
                _hoisted_20,
                _createTextVNode("Tables")
              ], 2))
            : _createCommentVNode("", true),
          (_unref(userRole) == 'Admin')
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: "/admin/panel",
                class: _normalizeClass({ active: currentRoute.value == 'panel' })
              }, [
                _hoisted_21,
                _createTextVNode("Reports")
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_22, [
            (_unref(userRole) == 'Admin')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass({
                    active:
                        currentRoute.value == 'marketing-call' ||
                        currentRoute.value == 'marketing-request' ||
                        currentRoute.value == 'count-report' ||
                        currentRoute.value == 'data-report',
                }),
                  href: "/admin/panel",
                  "data-bs-target": "#adminlist",
                  "data-bs-toggle": "collapse"
                }, [
                  _hoisted_23,
                  _createTextVNode("ADMIN REPORTS")
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["collapse", {
                    show:
                        currentRoute.value == 'marketing-call' ||
                        currentRoute.value == 'marketing-request' ||
                        currentRoute.value == 'count-report' ||
                        currentRoute.value == 'data-report',
                }]),
              style: {"background-color":"#005b77"},
              id: "adminlist"
            }, [
              _createElementVNode("ul", _hoisted_24, [
                _createElementVNode("li", _hoisted_25, [
                  _createElementVNode("a", {
                    href: "/admin/panel/marketing-call",
                    class: _normalizeClass({ active: currentRoute.value == 'marketing-call' })
                  }, "Required Code", 2),
                  _createElementVNode("a", {
                    href: "/admin/panel/marketing-request",
                    class: _normalizeClass({
                                active: currentRoute.value == 'marketing-request',
                            })
                  }, "Marketing Send", 2),
                  _createElementVNode("a", {
                    href: "/admin/panel/count-report",
                    class: _normalizeClass({
                                active: currentRoute.value == 'count-report',
                            })
                  }, "Count Report", 2),
                  _createElementVNode("a", {
                    href: "/admin/panel/data-report",
                    class: _normalizeClass({
                                active:
                                    currentRoute.value ==
                                    'data-report',
                            })
                  }, "Add Sub-system code", 2)
                ])
              ])
            ], 2)
          ]),
          (_unref(userRole) == 'Admin')
            ? (_openBlock(), _createElementBlock("a", {
                key: 3,
                href: "/admin/panel/contacts",
                class: _normalizeClass({ active: currentRoute.value == 'contacts' })
              }, [
                _hoisted_26,
                _createTextVNode("CONTACTS")
              ], 2))
            : _createCommentVNode("", true),
          (_unref(userRole) == 'MLO')
            ? (_openBlock(), _createElementBlock("div", {
                key: 4,
                class: _normalizeClass(["collapse", { show: _unref(route).path.includes('tables') }]),
                style: {"background-color":"#005b77"},
                id: "tablelist"
              }, [
                _createElementVNode("ul", _hoisted_27, [
                  _createElementVNode("li", _hoisted_28, [
                    _createVNode(_component_router_link, {
                      to: "/admin/panel/tables/primary",
                      class: _normalizeClass({
                            active:
                                _unref(route).path ==
                                '/admin/panel/tables/primary',
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Primary Property")
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      to: "/admin/panel/tables/second",
                      class: _normalizeClass({
                            active:
                                _unref(route).path ==
                                '/admin/panel/tables/second',
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Second Property")
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      to: "/admin/panel/tables/investment",
                      class: _normalizeClass({
                            active:
                                _unref(route).path ==
                                '/admin/panel/tables/investment',
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Investment")
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      to: "/admin/panel/tables/special-program",
                      class: _normalizeClass({
                            active:
                                _unref(route).path ==
                                '/admin/panel/tables/special-program',
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Special Program")
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      to: "/admin/panel/tables/foreign",
                      class: _normalizeClass({
                            active:
                                _unref(route).path ==
                                '/admin/panel/tables/foreign',
                        })
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Foreign")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("li", _hoisted_29, [
          (_unref(userRole) == 'Realtor')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass({
                    active:
                        currentRoute.value == 'budget' ||
                        currentRoute.value == 'getloan' ||
                        currentRoute.value == 'mortgage-payment' ||
                        currentRoute.value == 'total-financial-monthly' ||
                        currentRoute.value == 'total-cash-monthly',
                }),
                href: "/admin/panel",
                "data-bs-target": "#residentiallist",
                "data-bs-toggle": "collapse"
              }, [
                _hoisted_30,
                _createTextVNode("Residential")
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["collapse", {
                    show:
                        currentRoute.value == 'budget' ||
                        currentRoute.value == 'getloan' ||
                        currentRoute.value == 'mortgage-payment' ||
                        currentRoute.value == 'total-financial-monthly' ||
                        currentRoute.value == 'total-cash-monthly',
                }]),
            style: {"background-color":"#005b77"},
            id: "residentiallist"
          }, [
            _createElementVNode("ul", _hoisted_31, [
              _createElementVNode("li", _hoisted_32, [
                _createElementVNode("a", {
                  href: "/admin/panel/budget",
                  class: _normalizeClass({ active: currentRoute.value == 'budget' })
                }, "Budget", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/getloan",
                  class: _normalizeClass({ active: currentRoute.value == 'getloan' })
                }, "DTI Ratio", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/mortgage-payment",
                  class: _normalizeClass({
                                active: currentRoute.value == 'mortgage-payment',
                            })
                }, "Mortgage Payment", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/total-financial-monthly",
                  class: _normalizeClass({
                                active:
                                    currentRoute.value ==
                                    'total-financial-monthly',
                            })
                }, "Total Monthly Financing Payment", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/total-cash-monthly",
                  class: _normalizeClass({
                                active:
                                    currentRoute.value == 'total-cash-monthly',
                            })
                }, "Total Monthly Payment (Cash)", 2)
              ])
            ])
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_33, [
          (_unref(userRole) == 'Realtor')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass({
                    active:
                        currentRoute.value == 'flip-property-ready' ||
                        currentRoute.value == 'flip-as-is' ||
                        currentRoute.value == 'pasive-cash' ||
                        currentRoute.value == 'pasive-financial' ||
                        currentRoute.value == 'short-term-financial' ||
                        currentRoute.value == 'short-term-cash',
                }),
                href: "/admin/panel",
                "data-bs-target": "#investmentlist",
                "data-bs-toggle": "collapse"
              }, [
                _hoisted_34,
                _createTextVNode("Investment")
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["collapse", {
                    show:
                        currentRoute.value == 'flip-property-ready' ||
                        currentRoute.value == 'flip-as-is' ||
                        currentRoute.value == 'pasive-cash' ||
                        currentRoute.value == 'pasive-financial' ||
                        currentRoute.value == 'short-term-financial' ||
                        currentRoute.value == 'short-term-cash',
                }]),
            style: {"background-color":"#005b77"},
            id: "investmentlist"
          }, [
            _createElementVNode("ul", _hoisted_35, [
              _createElementVNode("li", _hoisted_36, [
                _createElementVNode("a", {
                  href: "/admin/panel/flip-property-ready",
                  class: _normalizeClass({
                                active:
                                    currentRoute.value == 'flip-property-ready',
                            })
                }, "Investment Property - Flip Ready", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/flip-as-is",
                  class: _normalizeClass({
                                active: currentRoute.value == 'flip-as-is',
                            })
                }, "Flip (As-Is)", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/pasive-cash",
                  class: _normalizeClass({
                                active: currentRoute.value == 'pasive-cash',
                            })
                }, "Pasive Cash", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/pasive-financial",
                  class: _normalizeClass({
                                active: currentRoute.value == 'pasive-financial',
                            })
                }, "Pasive Financing", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/short-term-financial",
                  class: _normalizeClass({
                                active:
                                    currentRoute.value == 'short-term-financial',
                            })
                }, "Short Term Financing", 2),
                _createElementVNode("a", {
                  href: "/admin/panel/short-term-cash",
                  class: _normalizeClass({
                                active: currentRoute.value == 'short-term-cash',
                            })
                }, "Short Term Cash", 2)
              ])
            ])
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_37, [
          (_unref(userRole) == 'Realtor')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "/admin/panel/foreign",
                class: _normalizeClass({ active: currentRoute.value == 'foreign' })
              }, [
                _hoisted_38,
                _createTextVNode("Foreign")
              ], 2))
            : _createCommentVNode("", true)
        ]),
        (_unref(userRole) == 'Realtor')
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, _hoisted_41))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_42, [
          (_unref(userRole) == 'Realtor')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: _normalizeClass(["text-start", { active: currentRoute.value == 'message' }]),
                href: "/admin/panel/message"
              }, [
                _hoisted_43,
                _createTextVNode("Sending Customer information ")
              ], 2))
            : _createCommentVNode("", true),
          (_unref(userRole) != 'Realtor')
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: _normalizeClass(["text-start", { active: currentRoute.value == 'message' }]),
                href: "/admin/panel/message"
              }, [
                _hoisted_44,
                _createTextVNode("Customer information")
              ], 2))
            : _createCommentVNode("", true)
        ]),
        (_unref(userRole) == 'Admin')
          ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
              _createElementVNode("a", {
                href: "/admin/panel/supportmessages",
                class: _normalizeClass({ active: currentRoute.value == 'message' })
              }, [
                _hoisted_46,
                _createTextVNode("support")
              ], 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_47, [
          _createElementVNode("a", {
            href: "/admin/panel/settings",
            class: _normalizeClass({ active: currentRoute.value == 'settings' })
          }, [
            _hoisted_48,
            _createTextVNode("Settings")
          ], 2)
        ]),
        _createElementVNode("li", _hoisted_49, [
          _createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(cerrarSesion, ["prevent"])
          }, [
            _hoisted_51,
            _createTextVNode("Log out")
          ], 8, _hoisted_50)
        ])
      ])
    ]),
    _hoisted_52
  ], 64))
}
}

})